
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {},
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'GESTAO_VM_COMENTARIO_TIPO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'GESTAO_VM_COMENTARIO_TIPO_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'GESTAO_VM_COMENTARIO_TIPO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'GESTAO_VM_COMENTARIO_TIPO_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					id: item.id,
					valor: item.nome
				}))
			};

        default:
            return state;
    }
}
